import { render, staticRenderFns } from "./DatabaseRecap.vue?vue&type=template&id=c8f8b3fa"
import script from "./DatabaseRecap.vue?vue&type=script&lang=js"
export * from "./DatabaseRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports